import React from "react";
import { Box, Button } from "@mui/material";

const ParrotBorderButton = ({ onClick, label, sx = {} }) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", marginBottom: "16px" }}>
      <Button
        variant="outlined"
        sx={{
          width: "100%",
          borderRadius: "50px",
          border: "1px solid #4CAF50", // Fallback solid border
          borderImage: `url("https://example.com/parrot-pattern.png") 30 stretch`, // Replace with your image
          backgroundColor: "transparent",
          color: "#4CAF50",
          "&:hover": {
            backgroundColor: "#E8F5E9",
            borderColor: "#45A049", // Darker green fallback
          },
          ...sx, // Allow additional styles to be passed
        }}
        onClick={onClick}
      >
        {label}
      </Button>
    </Box>
  );
};

export default ParrotBorderButton;